module.exports = __webpack_public_path__ + "067a8b731af946785aac0a72358e1bb1.svg";